module.exports = __webpack_public_path__ + "static/media/lens_classic-Chic.fe8a1bc1.png";